import React, { useState } from 'react';
import { Card, Input, Button } from '../../components/ui';
import { AlertTriangle, TrendingUp, Users } from 'lucide-react';
import { cn } from '../../lib/utils';

export function PetitionSignatureProjectorTool() {
  const [targetValid, setTargetValid] = useState('50000');
  const [validityRate, setValidityRate] = useState('70');
  const [daysRemaining, setDaysRemaining] = useState('45');
  const [currentSigs, setCurrentSigs] = useState('15000');

  const tgtValid = parseInt(targetValid) || 0;
  const vRate = parseFloat(validityRate) || 100;
  const days = parseInt(daysRemaining) || 1;
  const current = parseInt(currentSigs) || 0;

  const totalRawNeeded = Math.ceil(tgtValid / (vRate / 100));
  const rawRemaining = Math.max(0, totalRawNeeded - current);
  const dailyTarget = Math.ceil(rawRemaining / days);

  return (
    <div className="grid lg:grid-cols-2 gap-8 text-left">
      <div className="space-y-6">
        <Card className="p-6 space-y-4">
          <h3 className="text-lg font-bold">Signature Requirements</h3>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">Target Valid Signatures</label>
              <Input type="number" value={targetValid} onChange={e => setTargetValid(e.target.value)} />
            </div>
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">Est. Validity Rate (%)</label>
              <Input type="number" value={validityRate} onChange={e => setValidityRate(e.target.value)} />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">Raw Signatures Collected</label>
              <Input type="number" value={currentSigs} onChange={e => setCurrentSigs(e.target.value)} />
            </div>
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">Days Remaining</label>
              <Input type="number" value={daysRemaining} onChange={e => setDaysRemaining(e.target.value)} />
            </div>
          </div>
        </Card>
      </div>

      <div className="space-y-6">
        <Card className="p-6 bg-rose-50 border-rose-100 flex flex-col justify-center dark:bg-rose-900/20 dark:border-rose-800 h-full">
            <span className="text-[10px] uppercase font-bold text-rose-600 block mb-2 tracking-widest">Daily Raw Target</span>
            <p className="text-6xl font-black text-rose-700 font-mono mb-4">{dailyTarget}</p>
            <div className="border-t border-rose-200/50 pt-4 dark:border-rose-800/50 text-sm">
              <span className="font-bold text-rose-700/80 block">Total Raw Needed: {totalRawNeeded.toLocaleString()}</span>
              <span className="text-rose-700/80 block mt-1">Remaining to Collect: {rawRemaining.toLocaleString()}</span>
            </div>
        </Card>
      </div>
    </div>
  );
}

